<script>
export default {
  methods: {
    sortOptions(options) {
      return options.sort((a, b) => {
        const textA = a.text.toUpperCase()
        const textB = b.text.toUpperCase()
        if (textA < textB) {
          return -1
        }
        if (textA > textB) {
          return 1
        }
        return 0
      })
    },
  },
}
</script>
